import type * as React from "react"
import { CopyButton } from "@/components/app/copy-button"
import { cn } from "@/lib/utils"

export interface KeyValueItem {
  label: React.ReactNode
  value: React.ReactNode
  /** Adds a copy button for this raw value. */
  copy?: string
  mono?: boolean
  hidden?: boolean
}

/** Definition list for detail panes: label on the left, value on the right. */
export function KeyValueList({
  items,
  layout = "horizontal",
  className,
}: {
  items: KeyValueItem[]
  layout?: "horizontal" | "stacked"
  className?: string
}) {
  return (
    <dl
      className={cn("text-sm", layout === "horizontal" ? "divide-y" : "grid gap-4 sm:grid-cols-2", className)}
    >
      {items
        .filter((i) => !i.hidden)
        .map((item, idx) => (
          <div
            key={idx}
            className={cn(
              layout === "horizontal"
                ? "grid grid-cols-[minmax(7rem,35%)_1fr] items-center gap-3 py-2.5 first:pt-0 last:pb-0"
                : "space-y-1",
            )}
          >
            <dt className="text-muted-foreground text-[0.8125rem]">{item.label}</dt>
            <dd className={cn("flex min-w-0 items-center gap-1", item.mono && "font-mono text-[0.8rem]")}>
              <span className="min-w-0 truncate">{item.value ?? "—"}</span>
              {item.copy && <CopyButton value={item.copy} size="icon-xs" />}
            </dd>
          </div>
        ))}
    </dl>
  )
}
